import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmComponent } from '@app/shared/confirm/confirm.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownDialogComponent } from '@app/shared/dropdown-dialog/dropdown-dialog.component';
import { ErrorDialogManagerComponent } from '@app/shared/errors/error-dialog-manager/error-dialog-manager.component';
import { ErrorDialogComponent } from '@app/shared/errors/error-dialog-manager/error-dialog/error-dialog.component';

@NgModule({
  declarations: [ErrorDialogManagerComponent, ErrorDialogComponent],
  imports: [CommonModule, TranslateModule, MatIconModule, MatDialogModule],
  exports: [ErrorDialogManagerComponent, ErrorDialogComponent],
})
export class ErrorDialogManagerModule {}
